(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pyracraft-3d-hero"] && !Shopify.designMode) return;
  try {
    
  class PyracraftHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-pyracraft-slide]')];
      this.dots = [...this.querySelectorAll('[data-pyracraft-dot]')];
      this.index = 0;
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.pyracraftDot))));
      if (this.slides.length > 1) this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), 6500);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    }
  }
  customElements.define('pyracraft-hero-carousel', PyracraftHeroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pyracraft-3d-pathways"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const init = (scope = document) => scope.querySelectorAll('[data-pyracraft-comparison]').forEach((comparison) => {
      if (comparison.dataset.initialized) return;
      const range = comparison.querySelector('.pyracraft-3d-pathways__comparison-range');
      if (!range) return;
      comparison.dataset.initialized = 'true';
      const enabled = comparison.closest('.pyracraft-3d-pathways')?.dataset.autoPreview === 'true';
      let value = Number(range.value) || 50, direction = 1, frame = 0, last = 0;
      let visible = false, hover = false, focus = false, manual = false;
      const draw = () => comparison.style.setProperty('--comparison-position', `${value}%`);
      const canRun = () => enabled && !reducedMotion.matches && !document.hidden && visible && !hover && !focus && !manual;
      const stop = () => { if (frame) cancelAnimationFrame(frame); frame = 0; last = 0; };
      const animate = (time) => {
        if (!canRun()) { stop(); return; }
        if (last) {
          value += direction * Math.min(time - last, 50) * 0.008;
          if (value >= 72) { value = 72; direction = -1; }
          if (value <= 28) { value = 28; direction = 1; }
          range.value = String(value); draw();
        }
        last = time; frame = requestAnimationFrame(animate);
      };
      const sync = () => { if (!canRun()) { stop(); return; } if (!frame) frame = requestAnimationFrame(animate); };
      range.addEventListener('input', () => { manual = true; value = Number(range.value); draw(); sync(); });
      range.addEventListener('pointerdown', () => { manual = true; sync(); });
      range.addEventListener('keydown', () => { manual = true; sync(); });
      range.addEventListener('focus', () => { focus = true; sync(); });
      range.addEventListener('blur', () => { focus = false; sync(); });
      comparison.addEventListener('pointerenter', () => { hover = true; sync(); });
      comparison.addEventListener('pointerleave', () => { hover = false; sync(); });
      comparison.syncAutoPreview = sync;
      if ('IntersectionObserver' in window) new IntersectionObserver((entries) => { visible = entries.some((entry) => entry.isIntersecting); sync(); }, { threshold: 0.2 }).observe(comparison); else visible = true;
      draw(); sync();
    });
    const syncAll = () => document.querySelectorAll('[data-pyracraft-comparison]').forEach((item) => item.syncAutoPreview?.());
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('visibilitychange', syncAll);
    reducedMotion.addEventListener('change', syncAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
